import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "How quickly can you actually close?",
    a: "We typically close in 14–21 days from accepted offer. If you need to close faster, let us know — in many cases we can move sooner. Need more time? You pick the date.",
  },
  {
    q: "Do I need to clean or repair anything?",
    a: "No. We buy homes in as-is condition — cluttered, damaged, outdated, or anywhere in between. Take what you want, leave the rest. We handle it.",
  },
  {
    q: "Are there any fees or commissions?",
    a: "Zero commissions and no hidden fees. We also cover standard closing costs. The number we offer is the number you net.",
  },
  {
    q: "How do you calculate your offer?",
    a: "We look at recent comparable sales in your neighborhood, your home's condition, and the cost of needed repairs. Then we present a fair, transparent number — no lowball games.",
  },
  {
    q: "What types of properties do you buy?",
    a: "Single-family homes in Pennsylvania, New Jersey, Alabama, Texas, North Carolina, South Carolina, and Georgia. Owner-occupied, rented, vacant, or distressed — we'll take a look.",
  },
  {
    q: "Is there any obligation if I submit my info?",
    a: "None at all. Submitting your information gets you a free, no-obligation cash offer. You're free to say no.",
  },
];

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 lg:py-28"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-12">
          <span className="text-xs uppercase tracking-[0.2em] text-[#D95D39] font-medium">
            Common Questions
          </span>
          <h2 className="mt-3 font-[Outfit] font-semibold text-[#2C3D30] text-3xl sm:text-4xl lg:text-5xl tracking-tight">
            You&apos;ve got questions. We&apos;ve got straight answers.
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, idx) => (
            <AccordionItem
              key={f.q}
              value={`item-${idx}`}
              data-testid={`faq-item-${idx}`}
              className="bg-white border border-[#E2DDD7] rounded-2xl px-6 data-[state=open]:border-[#D95D39]/40 transition-colors"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${idx}`}
                className="font-[Outfit] font-medium text-left text-[#2C3D30] hover:no-underline text-base sm:text-lg"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#5B6B5F] text-sm sm:text-base leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
